import { render, staticRenderFns } from "./NoticesCard.vue?vue&type=template&id=fb42aea0&"
import script from "./NoticesCard.vue?vue&type=script&lang=js&"
export * from "./NoticesCard.vue?vue&type=script&lang=js&"
import style0 from "./NoticesCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports